export const REPORT_TYPES = [
  { Id: 'guard', Title: 'Guard' },
  { Id: 'consultant', Title: 'Consultant' },
] as const;
